import { css } from "styled-components"

export const HeroOverlay = css`
  background-color: #293743;
  mix-blend-mode: multiply;
`
